<template>
  <el-dialog :title="title" :visible.sync="visible">
    <div>
      <elSelect
        :title="'人员'"
        :ph="'请输入'"
        :options="options"
        v-model="modifyData.name"
      ></elSelect>

      <elSelect
        :title="'内容'"
        :ph="'示例文字'"
        :options="options"
        v-model="modifyData.content"
      ></elSelect>
      <div class="dateChoose">
        <span>
          日期
          <span style="color: red">* </span>
        </span>
        <el-date-picker
          v-model="modifyData.contdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerClick()">确 定</el-button> 
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    modifyData:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val); // visible 改变的时候通知父组件
      },
    },
  },
  methods: {
    handlerCancel() {
      this.visible = false;
    }, 
    handlerClick(){
      this.$emit("handler",this.modifyData)
      this.visible = false; 
    },
  },
};
</script>
<style  lang='scss' scoped>
 .el-date-editor.el-input__inner{
   width: 200px;
 }
</style>